var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.domainLoaded && _vm.domain.load_error
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Error ")]),
                      _c("gg-card-text", [
                        _vm._v(" " + _vm._s(_vm.domain.load_error) + " ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-row",
            {
              attrs: {
                align: "stretch"
              }
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [
                  _c(
                    "gg-card",
                    {
                      attrs: {
                        height: "100%"
                      }
                    },
                    [
                      _c("gg-card-header", [
                        _vm._v(
                          " " +
                            _vm._s("Information - ".concat(_vm.domain.domain)) +
                            " "
                        )
                      ]),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1",
                                  attrs: {
                                    cols: "8"
                                  }
                                },
                                [_vm._v(" Status ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1 d-inline-flex text-right",
                                  attrs: {
                                    cols: "4"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pb-1 pr-1",
                                      attrs: {
                                        small: "",
                                        color: _vm.statusColor(
                                          _vm.domain.status
                                        )
                                      }
                                    },
                                    [_vm._v(" mdi-circle ")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.domain.status) + " ")
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1",
                                  attrs: {
                                    cols: "8"
                                  }
                                },
                                [_vm._v(" Registration Date: ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1 d-inline-flex text-right",
                                  attrs: {
                                    cols: "4"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.domain.whmcs_registrationdate)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1",
                                  attrs: {
                                    cols: "8"
                                  }
                                },
                                [_vm._v(" Expiry Date: ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1 d-inline-flex text-right",
                                  attrs: {
                                    cols: "4"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.domain.whmcs_nextduedate))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1",
                                  attrs: {
                                    cols: "8"
                                  }
                                },
                                [_vm._v("Renewal Amount:")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1 d-inline-flex text-right",
                                  attrs: {
                                    cols: "4"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(_vm.domain.whmcs_recurringamount)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1",
                                  attrs: {
                                    cols: "8"
                                  }
                                },
                                [_vm._v(" Auto Renew: ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-1 d-inline-flex",
                                  attrs: {
                                    cols: "4"
                                  }
                                },
                                [
                                  _vm.cancellationData.autorenew
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "pb-1",
                                                staticStyle: {
                                                  color: "#4caf50"
                                                },
                                                attrs: {
                                                  small: ""
                                                }
                                              },
                                              [_vm._v(" mdi-circle ")]
                                            ),
                                            _vm._v(" On "),
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: {
                                                    name: "cancel",
                                                    params: {
                                                      service_id:
                                                        _vm.cancellationData.id
                                                    },
                                                    query: {
                                                      type:
                                                        _vm.cancellationTypes
                                                          .DOMAIN
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "20",
                                                      color: "blue"
                                                    }
                                                  },
                                                  [_vm._v("mdi-autorenew")]
                                                ),
                                                _vm._v(" Disable ")
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _c("div", [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "pb-1",
                                                staticStyle: {
                                                  color: "red"
                                                },
                                                attrs: {
                                                  small: ""
                                                }
                                              },
                                              [_vm._v(" mdi-circle ")]
                                            ),
                                            _vm._v(" Off "),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "#"
                                                },
                                                on: {
                                                  click: _vm.canAutorenewProceed
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "20",
                                                      color: "blue"
                                                    }
                                                  },
                                                  [_vm._v("mdi-autorenew")]
                                                ),
                                                _vm._v(" Enable ")
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6"
                  }
                },
                [
                  _c(
                    "gg-card",
                    {
                      attrs: {
                        height: "100%"
                      }
                    },
                    [
                      _c("gg-card-header", [_vm._v(" Domain options ")]),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c("registar-lock", {
                                attrs: {
                                  domainid: _vm.domainid
                                }
                              }),
                              _c("id-protect", {
                                attrs: {
                                  domainid: _vm.domainid
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.autorenewModalOpen
        },
        on: {
          close: _vm.closeModalAutorenew
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Enabling auto renew error ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _vm._v(
                  " Your domain is not eligible to enable auto renew. Please contact Billing for assistance. "
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    on: {
                      click: _vm.closeModalAutorenew
                    }
                  },
                  [_vm._v("Close")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.autorenewModalConfirmOpen
        },
        on: {
          close: _vm.closeModalAutorenewConfirm
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Enabling auto renew ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active."
                  )
                ]),
                _c("p", [
                  _vm._v("Are you sure you want to enable auto renewal?")
                ])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeModalAutorenewConfirm
                    }
                  },
                  [_vm._v("No")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.autorenewLoading
                    },
                    on: {
                      click: _vm.acceptModalAutorenewConfirm
                    }
                  },
                  [_vm._v("Yes")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }